import React from 'react';
import { AuthenticationHelpers  as Auth, requestHelpers } from '../../../../../../helpers/index';
import ThanksModal from '../../../../../common/elements/ThanksModal';
import { ErrorModal } from '../ui/ErrorModal';
class ExternalEndorsementForm extends React.Component {
    constructor () {
        super();
        this.state = {
            isError: false,
            isSuccess: false,
        }
        this.handleSubmit = this.handleSubmit.bind( this );
        this.handlePostToApi = this.handlePostToApi.bind( this );
    }

    handlePostToApi ( payload ) {
        requestHelpers
            .authenticatedPostRequest(  `/profiles/endorsement/${ payload.id }/complete`, { ...payload } )
            .then ( ( response ) => {
                this.setState({ isSuccess: true })
            })
            .catch( ( error ) => {
                console.log(`ERROR ${ error }`);
                this.setState({ isError: error.status })
            })
    }


    handleSubmit ( e ) {
        e.preventDefault();

        const form = e.target, payload= {};

        payload.hash = form.elements['hash'].value;
        payload.content = form.elements['content'].value;
        payload.company_name = form.elements['company_name'].value;
        payload.job_title = form.elements['job_title'].value;
        payload.id = form.elements['id'].value;

        this.handlePostToApi( payload );
    }

    render () {
        const formUrl = this.props.location.search;

        const id = Auth.getParameterByName('endorsement_id', formUrl),
            hash = Auth.getParameterByName('hash', formUrl),
            requester_first_name = Auth.getParameterByName('requester_first_name', formUrl),
            requester_last_name = Auth.getParameterByName('requester_last_name', formUrl),
            receiver_first_name = Auth.getParameterByName('receiver_first_name', formUrl),
            receiver_last_name = Auth.getParameterByName('receiver_last_name', formUrl);

        return (
            <div className="Site-content body-wrapper">
                <article className="container endorsement-form-body">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="text-center">
                                <h1 className="h1 brand-color">Write an Endorsement</h1>
                                <p className="p-tag"> Hello { receiver_first_name } { receiver_last_name }, please write your endorsement for { requester_first_name } { requester_last_name} below </p>
                            </div>
                            <form className="form-endorsement" onSubmit={ this.handleSubmit }>
                                <input name="hash" type="hidden" value={ hash || '' } />
                                <input name="id" type="hidden" value={ id || '' } />
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <label htmlFor="">Job Title:</label>
                                        <input className="form-control" type="text" name="job_title" placeholder='Referee job title' /><br/>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <label htmlFor="">Company:</label>
                                        <input className="form-control" type="text" name="company_name" placeholder='Referee company'/><br/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <label htmlFor="">Endorsement:</label>
                                        <textarea className="form-control" type="text" name="content" placeholder='Write your endorsement here...'/><br/>
                                        <button className="btn btn-primary btn-block">
                                            <span className="label">Submit</span>
                                            <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <ErrorModal
                                isOpen={ this.state.isError}
                                header={`Error ${ this.state.isError }`}
                                message={this.state.isError === 500
                                    ? `Oops something went wrong - this endorsement request has been cancelled and is no longer valid`
                                    : "Oops something went wrong - please try again or contact customer services "
                                }
                                onClose={ () => window.location = `https://intouchnetworks.com` }
                            />
                            <ThanksModal
                                isOpen={this.state.isSuccess}
                                message={`Your recommendation for ${ requester_first_name } ${ requester_last_name } has been submitted`}
                                onClose={ () => window.location = `https://intouchnetworks.com` }/>
                        </div>
                    </div>
                </article>
            </div>
        )
    }
}

export default ExternalEndorsementForm;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/ExternalEndorsementForm.js